<template>
    <el-dialog custom-class="lesson-expType-dialog" center width="600px" title="开始实验" :visible.sync="showDialog">
        <el-row v-if="expInfo.expMode != 2" class="border-no">
            <el-col  v-if="expInfo.expMode != 0">
                <div @click="selectType(expInfo)">
                    <img src="~@/assets/imgs/icon/experiment_local.png">
                    <p><span>本地实验</span></p>
                </div>
            </el-col>
            <el-col v-if="expInfo.expMode != 1">
                <div @click="selectType('remote')">
                    <img src="~@/assets/imgs/icon/experiment_long_range.png">
                    <p><span>远程实验</span></p>
                </div>
                <p class="tips">
                    <el-button type="success" size="small" @click="startReserva" v-if="expInfo.openReservation">立即预约
                    </el-button>
                </p>
            </el-col>
        </el-row>
        <el-row v-else>
            <el-col :span="12" v-if="expInfo.expMode != 0">
                <div @click="selectType(expInfo)">
                    <img src="~@/assets/imgs/icon/experiment_local.png">
                    <p><span>本地实验</span></p>
                </div>
            </el-col>
            <el-col :span="12"  v-if="expInfo.expMode != 1">
                <div @click="selectType('remote')">
                    <img src="~@/assets/imgs/icon/experiment_long_range.png">
                    <p><span>远程实验</span></p>
                </div>
                <p class="tips">
                    <el-button type="success" size="small" @click="startReserva" v-if="expInfo.openReservation">立即预约
                    </el-button>
                </p>
            </el-col>
        </el-row>
    </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            showDialog: false,
        }
    },
    props: {
        expInfo: {
            type: Object,
            default: () => { }
        }
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    methods: {
        selectType (type) {
            this.$emit('change', type)
        },
        setState (state) {
            this.showDialog = state
        }
    }
}
</script>

<style lang="scss">
.lesson-expType-dialog {
    &.el-dialog--center {
        .el-dialog__header {
            font-size: 24px;
            line-height: 3em;
            padding: 0;
            border-bottom: 1px solid #dcdcdc;
            color: #333;
            .el-dialog__title {
                margin-top: 0;
                font-size: inherit;
                line-height: inherit;
                color: inherit;
            }
        }
        .el-dialog__body {
            padding-top: 24px;
            padding-bottom: 24px;
            padding: 24px inherit;
            text-align: inherit;
            .el-col {
                font-size: 16px;
                color: #333;
                cursor: pointer;
                p {
                    span:hover {
                        border-bottom: 1px solid #000;
                    }
                }
                .tips {
                    width: calc(100% - 136px);
                    font-size: 14px;
                    text-align: center;
                    margin: 24px auto 0;
                    color: red;
                }
            }
            .el-col:nth-child(2n + 1) {
                border-right: 1px solid #dcdcdc;
            }
            .border-no{
                .el-col:nth-child(2n + 1) {
                    border-right: none;
                }
            }
        }
    }
}
</style>
